"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconWeatherUmbrella = function IconWeatherUmbrella(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M11.5 4A7.5 7.5 0 0 0 4 11.5V13h7v6l.008.175a2 2 0 0 0 3.405 1.229l-.706-.708-.095.083A1 1 0 0 1 12 18.998V13h7v-1.5A7.5 7.5 0 0 0 11.5 4m.221 2.004a5.5 5.5 0 0 1 5.24 4.84l.015.156H6.023l.016-.157A5.5 5.5 0 0 1 11.5 6z",
    clipRule: "evenodd"
  })));
};

export { IconWeatherUmbrella, IconWeatherUmbrella as default };
